<!--
  Only the `focusable` cell exposes its link to keyboard and assistive tech (one per row);
  that link is named after the cell's visible content.
-->
<template>
  <td :id="focusable ? cellId : undefined" class="relative">
    <slot />
    <RouterLink
      :to
      class="absolute inset-0"
      :tabindex="focusable ? undefined : -1"
      :aria-hidden="focusable ? undefined : 'true'"
      :aria-labelledby="focusable ? cellId : undefined"
    />
  </td>
</template>

<script setup lang="ts">
import { inject, useId } from "vue";
import { rowLinkToKey } from "./rowLink";

defineProps<{
  focusable?: boolean;
}>();

const to = inject(rowLinkToKey);
if (!to) throw new Error("RowLinkCell must be used inside RowLink");
const cellId = useId();
</script>
